import ButtonCloseMainPopup from "../ButtonCloseMainPopup";
import "./Settings.css";
import React, { useEffect, useState } from "react";
import { useTypedSelector } from "../../../hooks/useTypedSelector";
import { useActions } from "../../../hooks/useActions";
import PatreonButton from "./PatreonButton";
import { config } from "../../../config";
import { sounds } from "../../../sounds/sound";

function SettingsComponent() {
    const { user, error, isLoading } = useTypedSelector((state) => state.auth);
    const {
        editUser,
        setSystemMessage,
        setError,
        logout,
        applyPromocode,
        updateUser,
        setIsLoading,
    } = useActions();

    const [promocode, setPromocode] = useState("");

    const isNutakuOnlyPromocode = config.isNutaku === true;

    const loginToShow =
        user.login && user.login.includes("@") ? user.login : "none";

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (isLoading) {
            return;
        }

        const formData = new FormData(e.currentTarget);
        const email = (formData.get("email") as string)?.trim();
        const pass = (formData.get("password") as string)?.trim();
        const username = (formData.get("username") as string)?.trim();

        if (email || pass || username) {
            editUser(email, pass, username);
        }
    };

    const handlePromocodeSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (isLoading) {
            return;
        }

        const trimmedPromocode = promocode.trim();

        if (!trimmedPromocode) {
            setSystemMessage({
                isVisible: true,
                type: "info",
                text: "Enter promocode",
                action: null,
            });
            return;
        }

        try {
            await applyPromocode(trimmedPromocode);

            updateUser();
            sounds.open_box().play();

            setSystemMessage({
                isVisible: true,
                type: "info",
                text: `Promocode "${trimmedPromocode}" applied successfully`,
                action: null,
            });

            setPromocode("");
        } catch (e) {
            setIsLoading(false);
            setSystemMessage({
                isVisible: true,
                type: "info",
                text: "Promocode not found or already used",
                action: null,
            });
        }
    };

    useEffect(() => {
        if (error === "") {
            return;
        }

        if (error === "no error") {
            setSystemMessage({
                isVisible: true,
                type: "info",
                text: "Data saved successfully",
                action: null,
            });
        } else {
            setSystemMessage({
                isVisible: true,
                type: "info",
                text: error,
                action: null,
            });
        }

        setError("");
    }, [error, setError, setSystemMessage]);

    const renderLogoutButton = () => (
        <div
            className="settingButtonLogOut"
            onClick={() => {
                if (isLoading) {
                    return;
                }
                logout();
            }}
        ></div>
    );

    const renderLogoutSection = () => (
        <div className="settings-card settings-card--mini">
            <h2>Account</h2>
            <p className="muted">
                Current name: <strong>{user.name}</strong>
            </p>
            <div className="actions actions-center">
                {renderLogoutButton()}
            </div>
        </div>
    );

    const renderPromocodeSection = () => (
        <div className="settings-card">
            <h2>Promocode</h2>
            <br />

            <form className="settings-form" onSubmit={handlePromocodeSubmit}>
                <div className="field">
                    <label htmlFor="promocode">Enter your promocode</label>
                    <input
                        type="text"
                        id="promocode"
                        name="promocode"
                        value={promocode}
                        onChange={(e) => setPromocode(e.target.value)}
                        onMouseDown={(e) => e.stopPropagation()}
                        placeholder="Enter promocode"
                        autoComplete="off"
                        maxLength={20}
                    />
                </div>

                <div className="actions">
                    <button
                        type="submit"
                        className="applyPromoButton"
                        disabled={isLoading}
                    >
                    </button>
                </div>
            </form>
        </div>
    );

    return (
        <div className="main-popup-container">
            <ButtonCloseMainPopup />

            <div className="offersTitle">
                <div className="offersTitleText">Settings</div>
            </div>

            <div className="settingsContainer">
                {isNutakuOnlyPromocode ? (
                    <div className="SettingPatreonContainer">
                        {renderLogoutSection()}
                        {renderPromocodeSection()}
                    </div>
                ) : (
                    <>
                        <div className="SettingAuthContainer">
                            <div className="settings-card">
                                <h2>Account Credentials</h2>

                                {renderLogoutButton()}

                                <p className="muted">
                                    Current email: <strong>{loginToShow}</strong>
                                </p>
                                <p className="muted">
                                    Current name: <strong>{user.name}</strong>
                                </p>

                                <form className="settings-form" onSubmit={handleSubmit}>
                                    <div className="field">
                                        <label htmlFor="username">Enter your nickname</label>
                                        <input
                                            type="text"
                                            id="username"
                                            name="username"
                                            onMouseDown={(e) => e.stopPropagation()}
                                            placeholder={user.name}
                                            autoComplete="username"
                                            minLength={2}
                                            maxLength={20}
                                        />
                                    </div>

                                    <div className="field">
                                        <label htmlFor="email">Enter your email</label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            onMouseDown={(e) => e.stopPropagation()}
                                            placeholder={loginToShow}
                                            autoComplete="email"
                                        />
                                    </div>

                                    <div className="field">
                                        <label htmlFor="pass">
                                            Password (8 characters minimum)
                                        </label>
                                        <input
                                            type="password"
                                            id="pass"
                                            name="password"
                                            onMouseDown={(e) => e.stopPropagation()}
                                            autoComplete="current-password"
                                            minLength={8}
                                        />
                                    </div>

                                    <div className="actions">
                                        <button
                                            type="submit"
                                            className="setSettingsButton"
                                            disabled={isLoading}
                                        >
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <div className="SettingSeparator"></div>

                        <div className="SettingPatreonContainer">
                            <div className="settings-card">
                                <h2>Patreon Connection</h2>
                                <PatreonButton />
                            </div>

                            {renderPromocodeSection()}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default SettingsComponent;